export const EARLY_DOSE_MINUTES = 60;

export interface TimedDose {
  scheduledAt: string;
  order: { isStat?: boolean; status?: string };
}

export function localDateTimeValue(at: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}T${pad(at.getHours())}:${pad(at.getMinutes())}`;
}

export function givenAtFrom(value: string, fallback: Date): Date {
  const parsed = value ? new Date(value) : fallback;
  return Number.isNaN(parsed.getTime()) ? fallback : parsed;
}

export function doseIsEarly(dose: TimedDose, givenAt: Date): boolean {
  if (dose.order.isStat) return false;
  return (new Date(dose.scheduledAt).getTime() - givenAt.getTime()) / 60_000 > EARLY_DOSE_MINUTES;
}

export function doseNeedsReason(dose: TimedDose, outcome: string, givenAt: Date): boolean {
  return outcome !== 'given' || doseIsEarly(dose, givenAt);
}

export function doseCanBeRecorded(dose: { status: string; order: { status?: string } }, admissionOpen: boolean): boolean {
  return dose.status === 'due' && admissionOpen && (dose.order.status ?? 'active') === 'active';
}
